function hashStringToSeed(str) {
  let hash = 0
  for (let i = 0; i < str.length; i++) {
    const char = str.charCodeAt(i)
    hash = (hash << 5) - hash + char
    hash >>>= 0
  }
  return hash
}

function seededRandom(seed) {
  const a = 1664525
  const c = 1013904223
  const m = 4294967296
  seed = (a * seed + c) % m
  return seed / m
}

function generateAvatar(hashString) {
  if (!hashString || hashString.length === 0) {
    return 0
  }

  const seed = hashStringToSeed(hashString)
  let random = Math.floor(seededRandom(seed) * 9) + 1
  return random
}

export default generateAvatar
